import { Facility, Organization, PatientDTO } from "@metriport/api-sdk";

export type FacilitiesMap = { [index: string]: Facility };
export type PatientsMap = { [index: string]: PatientDTO };

type BaseMedicalAppState = {
  selectedFacility?: Facility;
  store?: {
    organization?: Organization;
    facilities?: FacilitiesMap;
    patients?: PatientsMap;
  };
};

export type MedicalAppState =
  | (BaseMedicalAppState & { isLoaded: false })
  | (Required<BaseMedicalAppState> & { isLoaded: true });

export enum MedicalAppStateActionType {
  update,
}

export interface MedicalAppStateAction {
  type: MedicalAppStateActionType;
  newState: BaseMedicalAppState | MedicalAppState;
}

export const reducer = (state: MedicalAppState, action: MedicalAppStateAction) => {
  switch (action.type) {
    case MedicalAppStateActionType.update:
      return {
        ...state,
        ...action.newState,
      };

    default:
      return state;
  }
};

export const initialState: MedicalAppState = {
  isLoaded: false,
};
